import React, {useState} from 'react';
import Fade from "react-reveal/Fade";
import {useInView, useInViewEffect} from "react-hook-inview";


const FadeWrapper = ({children, ...props}) => {
    // const [isVisible, setIsVisible] = useState(false)

    const [ref, inView] = useInView()


    return (
        <div ref={ref} className={'fadewrappper ' } >
            {/*<div style={{display: inView ? "block" : "none"}}>*/}


            <Fade {...props} spy={inView} >{children}</Fade>
            {/*</div>*/}
        </div>

    )
};


export default FadeWrapper;


